RivalIQ.module('apps', function (apps, App, Backbone, Marionette, $, _) {

    'use strict';

    const Registration = apps.Registration = window.createMarionetteApp();
    Registration.name = 'Registration';

    Registration.addRegions({
        loading: '.x-loading',
        mainRegion: '.x-main-region'
    });
});
